














































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import ContactJson from "../../shared/ContactJson";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "OverlaySendMailsExtern",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {
    contacts: Array as PropType<ContactJson[]>,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      detailsTitle: "E-Mail Adressen",
      filterMailTypePrivate: false as boolean,
      filterMailTypeWork: false as boolean,
      selectedMailAddresses: undefined as string[] | null | undefined,
    };
  },
  created() {},
  mounted() {},
  methods: {
    closeDetails() {
      this.$emit("closeOverlay");
    },

    selectMailAddresses() {
      this.selectedMailAddresses = null;

      var mailAddresses: string[] = [];

      for (let contact of this.contacts) {
        if (this.filterMailTypePrivate) {
          if (contact.email != "" && !mailAddresses.includes(contact.email)) {
            mailAddresses.push(contact.email);
          }
        }

        if (this.filterMailTypeWork) {
          if (contact.emailWork != "" && !mailAddresses.includes(contact.emailWork)) {
            mailAddresses.push(contact.emailWork);
          }
        }
      }

      this.selectedMailAddresses = mailAddresses;
    },

    openMailClient() {
      var mailToString = "mailto:" + GeneralInfos.email;

      if (this.selectedMailAddresses) {
        mailToString += "?bcc=";

        mailToString += this.selectedMailAddresses.join(";");
      }

      if (mailToString.length < 2048) {
        window.location.href = mailToString;
        //window.open(mailtoString, "_blank")
      } else {
        alert(
          "Leider sind es zu viele E-Mail Adressen, um automatisch eine neue E-Mail anzulegen. Bitte kopieren Sie die E-Mail Adressen manuell."
        );
      }
    },
  },

  watch: {},

  computed: {},
});
